import type { BlockmetaValidationReason, ParseBlockmetaPayloadResult } from './payload.js';
import { type AcceptedBlockmetaSnapshot, parseBlockmetaPayload } from './payload.js';

export interface RejectedBlockmetaPayload {
  readonly reason: BlockmetaValidationReason;
  readonly receivedAtMs: number;
}

export class LatestBlockmetaStore {
  private latest: AcceptedBlockmetaSnapshot | null = null;
  private lastRejected: RejectedBlockmetaPayload | null = null;

  acceptPayload(
    subject: string,
    payload: Uint8Array,
    receivedAtMs: number,
  ): ParseBlockmetaPayloadResult {
    const result = parseBlockmetaPayload(subject, payload, receivedAtMs);
    if (!result.ok) {
      this.lastRejected = { reason: result.reason, receivedAtMs };
      return result;
    }

    const current = this.latest;
    if (current !== null) {
      if (result.snapshot.timestamp < current.timestamp) {
        this.lastRejected = { reason: 'regressing_block_meta', receivedAtMs };
        return { ok: false, reason: 'regressing_block_meta' };
      }
      if (
        result.snapshot.timestamp === current.timestamp &&
        result.snapshot.blockhash !== current.blockhash &&
        result.snapshot.receivedAtMs <= current.receivedAtMs
      ) {
        this.lastRejected = { reason: 'regressing_block_meta', receivedAtMs };
        return { ok: false, reason: 'regressing_block_meta' };
      }
    }

    this.latest = result.snapshot;
    return result;
  }

  getLatest(): AcceptedBlockmetaSnapshot | null {
    return this.latest;
  }

  getLastRejected(): RejectedBlockmetaPayload | null {
    return this.lastRejected;
  }

  clear(): void {
    this.latest = null;
    this.lastRejected = null;
  }
}

const STORE = new LatestBlockmetaStore();

export function getBlockmetaStore(): LatestBlockmetaStore {
  return STORE;
}
